import React from 'react'
import ReactGA from 'react-ga'
import PropTypes from 'prop-types'

import { useRestaurant } from '../RestaurantProvider/RestaurantProvider'

import { IfAuthenticated } from '../IfAuthenticated/IfAuthenticated'
import { useAuth } from '../AuthProvider/AuthProvider'
import { useGetCart } from '../CartQuery/CartQuery'
import Drawer from '../Drawer/Drawer'
import NavigationDrawerHeader from './NavigationDrawerHeader/NavigationDrawerHeader'
import { FlagOn } from '../FeatureFlag/FeatureFlag'
import { Link } from 'react-router-dom'
import { Anchor } from '../Anchor/Anchor'
import { GiftCardLinks } from './GiftCardLinks/GiftCardLinks'
import { PoweredByToast } from '../PoweredByToast/PoweredByToast'

import './NavigationDrawer.css'

const NavigationDrawer = ({ onClose }) => {
  const { logout } = useAuth()
  const { getRestaurantPath } = useRestaurant()
  const openData = {
    category: 'Drawer',
    action: 'open'
  }
  const closeData = {
    category: 'Drawer',
    action: 'close'
  }

  const { cart } = useGetCart()

  const logoutAndTrack = () => {
    logout({
      variables: {
        input: {
          cart
        }
      }
    })
    ReactGA.event({
      category: 'User Account',
      action: 'Logout'
    })
  }

  return (
    <Drawer
      openData={openData}
      closeData={closeData}
      header={<NavigationDrawerHeader onClose={onClose} />}
      onClose={onClose}
      footer={<PoweredByToast styleName='poweredBy' />}
    >
      <ul styleName='list'>
        <IfAuthenticated>
          <FlagOn name='oo-v3-reorder'>
            <li>
              <Link
                data-testid='nav-drawer-my-orders'
                styleName='listItem'
                to={getRestaurantPath('orders')}
                onClick={onClose}
              >
                My Orders
              </Link>
            </li>
          </FlagOn>
          <li>
            <Link
              data-testid='nav-drawer-my-account'
              styleName='listItem'
              to={getRestaurantPath('account')}
              onClick={onClose}
            >
              My Account
            </Link>
          </li>
        </IfAuthenticated>
        <GiftCardLinks />
        <li>
          <Anchor
            data-testid='nav-drawer-link-privacy'
            styleName='listItem'
            href='https://pos.toasttab.com/privacy'
            target='_blank'
            eventData={{
              category: 'Drawer',
              action: 'Privacy Statement'
            }}
          >
            Privacy Statement
          </Anchor>
        </li>
        <li>
          <Anchor
            data-testid='nav-drawer-link-terms'
            eventData={{
              category: 'Drawer',
              action: 'Diner Terms of Service'
            }}
            styleName='listItem'
            href='https://pos.toasttab.com/terms-of-service/#diner-tos'
            target='_blank'
          >
            Diner Terms of Service
          </Anchor>
        </li>

        <IfAuthenticated>
          <li>
            <button
              data-testid='nav-drawer-logout'
              styleName='listItem'
              onClick={logoutAndTrack}
            >
              Logout
            </button>
          </li>
        </IfAuthenticated>
      </ul>
    </Drawer>
  )
}

NavigationDrawer.propTypes = {
  onClose: PropTypes.func.isRequired
}

export default NavigationDrawer
